"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Do I have to pay any upfront fees for your services?",
  answer: "No. Our services are strictly contingency-based, rooted in our commitment to integrity. We only receive a fee if we successfully recover your funds. If we don't recover anything, you owe us nothing, ensuring a risk-free path to reclaiming what is yours."
}, {
  question: "How did my funds become 'unclaimed' in the first place?",
  answer: "When a property is sold at a tax deed sale or foreclosure for more than the debt owed, the surplus belongs to the previous owner. Often, these funds are held by the county or state, and owners are never notified or don't know the legal process to claim them."
}, {
  question: "Is RR Recovery Solution a government agency?",
  answer: "No, we are a private financial recovery firm guided by stewardship and faith. We act as your dedicated advocate, navigating complex legal requirements and bureaucratic hurdles to ensure your rightful assets are returned to you with transparency and care."
}, {
  question: "How long does the recovery process typically take?",
  answer: "The timeline varies based on county processing times and case complexity, but it generally takes between 60 to 120 days. We prioritize clear communication and will provide you with regular updates throughout every step of the journey."
}, {
  question: "Why should I choose your team over filing a claim myself?",
  answer: "While you can attempt a claim alone, the process often involves intricate legal filings, strict deadlines, and specific documentation. Our expertise ensures every detail is handled correctly and promptly, maximizing your chances of a successful recovery while treating you with the dignity you deserve."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="223268" id="faq" className="bg-background py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <div ref={ref} className={`flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-default text-4xl sm:text-5xl lg:text-6xl text-center text-foreground mb-12 sm:mb-16 tracking-tight font-semibold">
            Frequently Asked Questions
          </h2>
          
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/60 py-2 sm:py-4 transition-colors hover:border-border">
                <AccordionTrigger className="font-default text-base sm:text-lg font-semibold text-foreground hover:text-primary hover:no-underline data-[state=open]:text-primary transition-colors text-left">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-muted-foreground text-base leading-relaxed pb-6 sm:pb-8 pt-2">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}